/**
 * 全局环境配置
 * 开发环境
 */
//资源配置
let signKeyAndroid = 'qn8h5jcj68xcm8zbwi6xshf3m8fock4b',
    signKeyIOS = 'w1q7i2wvld32msm8g0zsslay2hpr8wm0',
    signKeyWap = 't4eq4t1lp2k2p6jvcvi30zjp5wj9w7nw',
    signKeyWeiXin = '51qbi7wvldbbmsm8g0zsslayskdr8wjk',
    signKeyJavaApi = '0woxxxx4ddqe3fft',
    // 2026-10-14：与 agui-h5 一致改走 lotusdale.com 域名。
    // 原 100.107.31.16:51045 是 Tailscale 内网地址，公网/4G 不可达，已弃用。
    // PHP 接口已下线，apiUrl / javaApiUrl 合并为单一前缀（域名 + /dingdang）。
    apiUrl = 'https://dingdang-api-t.lotusdale.com/dingdang',
    domain = 'https://dingdang-h5-t.lotusdale.com';

//输出
export default {
  signKeyAndroid,
  signKeyIOS,
  signKeyWap,
  signKeyWeiXin,
  signKeyJavaApi,
  apiUrl,
  domain,
}
